import React, { useEffect, useState } from "react";
import "style/Footer.scss";

import { Link } from "react-router-dom";

import en from "../config/i18n/english/english";
import legacy from "config/i18n/legacy";
import landing from "config/i18n/landing";
import useLang, { resolveLang } from "hooks/useLang";
import ui from "config/i18n/ui";

import { default as SvgHeaderTitle } from "assets/SvgHeaderTitle.svg";
import { default as SvgFooterSocialMediaLinkedin } from "assets/SvgFooterSocialMediaLinkedin.svg";
import { default as SvgFooterSocialMediaXing } from "assets/SvgFooterSocialMediaXing.svg";
import { default as SvgFooterPhone } from "assets/SvgFooterPhone.svg";
import { default as SvgFooterMail } from "assets/SvgFooterMail.svg";
import { default as SvgFooterCompany2 } from "assets/SvgFooterCompany2.svg";
import { default as SvgFooterCompany3 } from "assets/SvgFooterCompany3.svg";
import { default as SvgFooterCompany4 } from "assets/SvgFooterCompany4.svg";

const Footer = () => {
  const [language, setLanguage] = useState<any>(en);
  const lang = useLang();
  const nav = landing[lang].nav;
  const aria = ui[lang].aria;

  useEffect(() => {
    setLanguage(legacy[resolveLang()]);
  }, []);

  const funding = [
    // SvgFooterCompany2 is the FFG logo, SvgFooterCompany3 the Vienna
    // Business Agency — captions are index-matched in both i18n files.
    { img: SvgFooterCompany2, label: language.footer.FOOTER_COMPANIES[0] },
    { img: SvgFooterCompany3, label: language.footer.FOOTER_COMPANIES[1] },
    { img: SvgFooterCompany4, label: language.footer.FOOTER_COMPANIES[2] },
  ];

  return (
    <footer className="footer">
      <div className="shell">
        <div className="footer__top">
          <div className="footer__brand">
            <img src={SvgHeaderTitle} className="footer__logo" alt="MARKSIM" />
            <p className="footer__company">MARKSIM Services GmbH</p>
            <div className="footer__social">
              <a
                href={process.env.React_App_LINKEDIN}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
              >
                <img src={SvgFooterSocialMediaLinkedin} alt="LinkedIn" />
              </a>
              <a
                href={process.env.React_App_XING}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Xing"
              >
                <img src={SvgFooterSocialMediaXing} alt="Xing" />
              </a>
            </div>
          </div>

          <div className="footer__contact">
            <p className="footer__claim">
              {language.footer.contactHeader[0]}{" "}
              <span className="text-gradient">
                {language.footer.contactHeader[1]}
              </span>
            </p>
            <p className="footer__contact-label">
              {language.footer.contactBody}
            </p>
            <div className="footer__contact-links">
              <a href="tel:004312051085250">
                <img src={SvgFooterPhone} alt="" aria-hidden="true" />
                +43 1 205 108 525-0
              </a>
              <a href="mailto:sales-team@marksim.org">
                <img src={SvgFooterMail} alt="" aria-hidden="true" />
                sales-team@marksim.org
              </a>
            </div>
          </div>
        </div>

        <div className="footer__funding">
          {funding.map((item, index) => (
            <figure key={index}>
              <img src={item.img} alt={item.label || "Funding partner"} />
              {item.label ? <figcaption>{item.label}</figcaption> : null}
            </figure>
          ))}
        </div>

        <div className="footer__bottom">
          <span>&copy; MARKSIM {new Date().getFullYear()}</span>
          <nav className="footer__bottom-links" aria-label={aria.footer}>
            <Link to="/marksim">{nav.marksim}</Link>
            <Link to="/ms-trader">{nav.mstrader}</Link>
            <Link to="/jama">{nav.jama}</Link>
            <Link to="/contact">{language.footer.contact}</Link>
            <Link to="/hiring">{nav.hiring}</Link>
            <Link to="/imprint">
              {language.footer.imprint} &amp; {language.footer.GDPR}
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
